import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { SubscriptionFormProps } from '.';
import { STRIPE_PUBLISH_KEY } from '../../src/env';
import { createSubscription } from '../../utils/backend-api/stripe';
import { Spinner } from '../BaseUI';
import PaymentMethod from './PaymentMethod';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);
const PaymentForm = ({
  buttonText,
  isUserCBPT,
  referringSubscriberName,
  referringSubscriberGuid,
  selectedOffer,
  stripeCustomerId,
  userNextBillingDate,
}: SubscriptionFormProps) => {
  const [clientSecret, setClientSecret] = useState('');
  const [subscriptionId, setSubscriptionId] = useState('');
  const isReferral = !!referringSubscriberName;

  useEffect(() => {
    (async () => {
      try {
        const { clientSecret, subscriptionId } = await createSubscription({
          code: selectedOffer.code,
          stripe_customer_id: stripeCustomerId,
        });
        setClientSecret(clientSecret);
        setSubscriptionId(subscriptionId);
      } catch {
        toast.error('Something went wrong. Please refresh this page or try again later.');
      }
    })();
  }, [stripeCustomerId, selectedOffer.code]);

  return (
    <>
      {clientSecret ? (
        <Elements key={clientSecret} stripe={stripePromise} options={{ clientSecret }}>
          <PaymentMethod
            buttonText={buttonText}
            isReferral={isReferral}
            isUserCBPT={isUserCBPT}
            referringSubscriberName={referringSubscriberName}
            referringSubscriberGuid={referringSubscriberGuid}
            selectedOffer={selectedOffer}
            subscriptionId={subscriptionId}
            userNextBillingDate={userNextBillingDate}
          />
        </Elements>
      ) : (
        <div className="text-center my-16">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default PaymentForm;
